import { MenuSidebarType } from '@/types/menu';
import { BillingIcon, StoresIcon } from './icon';
import { Building2, ClipboardList, FileClock, Package, Settings2, Users } from 'lucide-react';
import { RiCoupon2Line } from 'react-icons/ri';

export const sideBarItem: MenuSidebarType = [
  {
    label: 'Tổng quan',
    items: [{ label: 'Dashboard', icon: StoresIcon, route: '/admin/dashboard' }],
  },
  {
    label: 'Khách hàng',
    items: [
      { label: 'Khách hàng', icon: Users, route: '/admin/customers' },
      { label: 'Công ty', icon: Building2, route: '/admin/companies' },
    ],
  },
  {
    label: 'Đơn hàng & thanh toán',
    items: [
      { label: 'Đơn hàng', icon: ClipboardList, route: '/admin/orders' },
      { label: 'Hóa đơn', icon: BillingIcon, route: '/admin/invoices' },
      { label: 'Coupon', icon: RiCoupon2Line, route: '/admin/coupons' },
      { label: 'Cổng Thanh toán', icon: RiCoupon2Line, route: '/admin/payment-settings' },
    ],
  },
  {
    label: 'Catalog',
    items: [
      { label: 'Danh mục dịch vụ', icon: Package, route: '/admin/catalog' },
      { label: 'Form fields', icon: Settings2, route: '/admin/form-fields' },
    ],
  },
  {
    label: 'Hệ thống',
    items: [
      { label: 'Thông báo', icon: Settings2, route: '/admin/notifications' },
      { label: 'Audit log', icon: FileClock, route: '/admin/audit' },
    ],
  },
];
